import type React from 'react';

const DEFAULT_ACCENT = '522e91';

// An entity's color (a program's, a unit's) as a wash over the surface, the way the lessons table
// paints its unit headers: same hex, low alpha, so it reads as the surface tinted rather than a bar.
export const tintStyle = (hex: string | null | undefined): React.CSSProperties => (
  { backgroundColor: `#${hex || DEFAULT_ACCENT}20` }
);
